export default "__VITE_ASSET__C6rLqYr0__"